var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 122,
    viewBox: "0 0 150 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    clipPath: "url(#clip0_658_4670)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M138.151 65.8231V57.9323C138.151 44.8473 127.58 34.2433 114.496 34.2433H78.9578V22.9588C83.5463 21.3243 86.8569 16.993 86.8569 11.8404C86.8569 5.29372 81.5466 -0.00830078 75.0083 -0.00830078C68.47 -0.00830078 63.1596 5.29372 63.1596 11.8404C63.1596 16.993 66.462 21.3326 71.0587 22.9588V34.235H35.5626C22.4776 34.235 11.8487 44.839 11.8487 57.924V65.8148C5.30202 65.8148 0 71.1168 0 77.6552C0 84.1935 5.30202 89.5038 11.8487 89.5038V97.4112C11.8487 110.463 22.4776 121.092 35.5626 121.092H114.504C127.589 121.092 138.16 110.463 138.16 97.4112V89.5038C144.706 89.5038 150.008 84.2018 150.008 77.6552C150.008 71.1085 144.706 65.8148 138.16 65.8148L138.151 65.8231ZM130.294 97.4195C130.261 106.14 123.216 113.193 114.496 113.193H35.5626C26.842 113.193 19.7644 106.14 19.7644 97.4195V57.9323C19.7644 49.2117 26.842 42.159 35.5626 42.1341H114.504C123.224 42.1673 130.277 49.2117 130.302 57.9323V97.4195H130.294Z",
    fill: "#BFE6F0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M60.7616 67.6152C59.2182 66.0719 56.729 66.0719 55.1857 67.6152L50.7134 72.0875L46.2411 67.6152C44.6978 66.0719 42.2086 66.0719 40.6653 67.6152C39.122 69.1586 39.122 71.6478 40.6653 73.1911L45.1376 77.6634L40.6653 82.1357C39.122 83.679 39.122 86.1682 40.6653 87.7115C42.2086 89.2548 44.6978 89.2548 46.2411 87.7115L50.7134 83.2392L55.1857 87.7115C56.729 89.2548 59.2182 89.2548 60.7616 87.7115C62.3049 86.1682 62.3049 83.679 60.7616 82.1357L56.2893 77.6634L60.7616 73.1911C62.3049 71.6478 62.3049 69.1586 60.7616 67.6152Z",
    fill: "#BFE6F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M104.904 77.6634L109.376 73.1911C110.919 71.6478 110.919 69.1586 109.376 67.6152C107.832 66.0719 105.343 66.0719 103.8 67.6152L99.3277 72.0875L94.8554 67.6152C93.3121 66.0719 90.8229 66.0719 89.2796 67.6152C87.7362 69.1586 87.7362 71.6478 89.2796 73.1911L93.7518 77.6634L89.2796 82.1357C87.7362 83.679 87.7362 86.1682 89.2796 87.7115C90.8229 89.2548 93.3121 89.2548 94.8554 87.7115L99.3277 83.2392L103.8 87.7115C105.343 89.2548 107.832 89.2548 109.376 87.7115C110.919 86.1682 110.919 83.679 109.376 82.1357L104.904 77.6634Z",
    fill: "#BFE6F0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_658_4670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 121.1,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.f21ffaf2fc03a568ec1b9f74e64f6891.svg";
export { ForwardRef as ReactComponent };